<template>
  <TheTwoColumnsLayout
      :leftColumnClass="`col-md-8 bg-vue`"
      :rightColumnClass="`col-md-4`"
      :fullsize="true"
  >
    <template #leftCol>
      <div class="mt-5 text-center">
        <div class="display-1 my-5">
          Der Shop
        </div>
        <div class="display-4 my-5">
          Erhalten Sie Zugriff auf exklusive Artikel
        </div>
        <div class="my-5 offset-4 col-4">
          <img src="@/assets/shopping.svg" class="img-fluid" alt="">
        </div>
      </div>
    </template>
    <template #rightCol>
      <transition
        enter-active-class="animate__animated animate__zoomIn"
        leave-active-class="animate__animated animate__zoomOut"
        mode="out-in"
      >
        <component
            :is="componentName"
            @change-component="changeComponent"
        >

        </component>
      </transition>
    </template>
  </TheTwoColumnsLayout>

</template>

<script>
import TheTwoColumnsLayout from "@/layout/TheTwoColumnsLayout.vue";
import RegisterForm from "@/components/auth/RegisterForm.vue";
import LoginForm  from "@/components/auth/LoginForm.vue";
export default {
  name: "HomePage",
  components: {
    TheTwoColumnsLayout,
    RegisterForm,
    LoginForm,
  },
  data() {
    return {
      //121;
      componentName: "RegisterForm",
    }
  },
  methods: {
    // 121;
    changeComponent( payload ) {
      this.componentName = payload.componentName;
    }
  }
}
</script>

<style scoped>

</style>/